// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import { connect } from 'react-redux';
import { Preference } from '@ta/lithium.context';

type ExternalProps = {|
  +children: React.Node,
|};

type StateProps = {|
  +currency: string,
|};

type Props = {|
  ...StateProps,
  ...ExternalProps,
|};

/**
 * The preference provider for the lithium bridge.
 * This is separate from the lithium preference provider (@ta/lithium.preference) in that the lithium version depends directly
 * on the cookie value between page loads. Pre-lithium, we'd just reload the page, so we continue to do that for this version
 * of the provider.
 */
const PreferenceProvider = ({ currency, children }: Props) => {
  const context = React.useMemo(
    () => ({
      currency,
      update: {
        setCurrency: newCurrency => {
          __non_webpack_require__(['trjs!ta/util/Currency'], module =>
            module.setCurrencyAndReload(newCurrency, currency),
          );
        },
      },
    }),
    [currency],
  );

  return <Preference.Provider value={context}>{children}</Preference.Provider>;
};

export default connect<Props, ExternalProps, StateProps, _, _, _>(
  (state): StateProps => ({
    currency: state.i18n.currencyCode,
  }),
)(PreferenceProvider);
